import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subject } from 'rxjs';
import { IdentityService } from 'src/app/core/identity.service';
import { CandidateNotes } from 'src/app/recruiting/candidates/new-profile/models/candidate-notes';
import { RecruitingService } from 'src/app/recruiting/recruiting.service';
import { FeatureFlag } from 'src/app/shared/models/enums/feature-flag';

@UntilDestroy()
@Component({
    selector: 'nova-v1-notes',
    templateUrl: './v1-notes.component.html',
    styleUrls: ['./v1-notes.component.scss'],
    animations: [
        trigger('balloonEffect', [
            state(
                'initial',
                style({
                    opacity: 0
                })
            ),
            state(
                'final',
                style({
                    opacity: 1
                })
            ),
            transition('initial=>final', animate('1500ms')),
            transition('final=>initial', animate('1500ms'))
        ])
    ],
    standalone: true,
    imports: [ReactiveFormsModule, MatIconModule]
})
export class V1NotesComponent implements OnChanges, OnDestroy {
    @Input()
    candidateId: number;

    recruiterId: number;

    @Output()
    dataChanged = new EventEmitter();

    travelNeedsSaveStatus = 'initial';
    jobDesiresSaveStatus = 'initial';

    travelNeeds = new UntypedFormControl();
    jobDesires = new UntypedFormControl();

    private readonly _cleanup$ = new Subject();
    featureFlag = FeatureFlag;

    constructor(
        private readonly recruitingService: RecruitingService,
        private readonly identityService: IdentityService
    ) {
        this.recruiterId = identityService.current.contactId;
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.recruitingService
            .getCandidateNotes(this.candidateId)
            .pipe(untilDestroyed(this))
            .subscribe((candidateNotes: CandidateNotes) => {
                this.travelNeeds.setValue(candidateNotes.travelNeeds);
                this.jobDesires.setValue(candidateNotes.jobDesires);
            });
    }

    ngOnDestroy(): void {
        this._cleanup$.next(true);
        this._cleanup$.complete();
    }

    saveTravelNeeds() {
        this.recruitingService
            .updateTravelNeeds(this.recruiterId, this.candidateId, this.travelNeeds.value)
            .pipe(untilDestroyed(this))
            .subscribe(() => {
                this.travelNeedsSaveStatus = 'final';
                setTimeout(() => {
                    this.travelNeedsSaveStatus = 'initial';
                    this.dataChanged.emit();
                }, 2000);
            });
    }

    saveJobDesires() {
        this.recruitingService
            .updateJobDesires(this.recruiterId, this.candidateId, this.jobDesires.value)
            .pipe(untilDestroyed(this))
            .subscribe(() => {
                this.jobDesiresSaveStatus = 'final';
                setTimeout(() => {
                    this.jobDesiresSaveStatus = 'initial';
                    this.dataChanged.emit();
                }, 2000);
            });
    }
}
